import {Action} from "@ngrx/store";
import {ACTION, STATUS} from "../constant";

const INIT_STATE = {
  data: null,
  status: null
};

export function PARTICIPATION_FORM_LIST_REDUCER(state = INIT_STATE, action: Action) {
  switch (action.type) {
    case ACTION.LOAD_PARTICIPATION_FORMS:
      return Object.assign({}, state, {status: STATUS.IN_PROGRESS});
    case ACTION.LOAD_PARTICIPATION_FORMS_COMPLETED:
      return Object.assign({}, state, {data: action.payload, status: STATUS.COMPLETED});
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/reducer/participation-form-list.reducer.ts